import { lazy, useEffect } from "react";
import { infoPortalRoutes } from "./infoPortalRoutes";

const PageHeader = lazy(() =>
    import("../teacher-role/shared/Components/Navigation/PageHeader")
);
const HomeNavigation = lazy(() =>
    import("../teacher-role/shared/Components/Navigation/HomeNavigation")
);
const StudentDashboardView = lazy(() =>
    import("../students/pages/StudentDashboardView")
);
const StudentDetailView = lazy(() =>
    import("../students/pages/StudentDetailView")
);
const UpdateStudentView = lazy(() =>
    import("../students/pages/UpdateStudentView")
);
const ProfileView = lazy(() => import("../users/pages/profile/ProfileView"));
const HelpCenterView = lazy(() => import("../help-center/pages/HelpCenterView"));

const StudentsRedirect = () => {
  useEffect(() => {
    window.location.href = import.meta.env.VITE_ACADEMIC_BASE_URL + "/students";
  }, []);
  return null;
};

export const studentRoutes = [
    {
        path: "/",
        element: (
            <PageHeader>
                <StudentDashboardView />
            </PageHeader>
        ),
    },
    {
        path: "/help-center",
        element: (
            <PageHeader>
                <HelpCenterView />
            </PageHeader>
        ),
    },
    // {
    //     path: "/dashboard/students/:studentId",
    //     element: (
    //         <PageHeader>
    //             <StudentDetailView />
    //         </PageHeader>
    //     ),
    // },
    // {
    //     path: "/dashboard/students/:studentId/update",
    //     element: (
    //         <PageHeader>
    //             <UpdateStudentView />
    //         </PageHeader>
    //     ),
    // },
    { path: "/dashboard/students/:studentId", element: <StudentsRedirect /> },
    { path: "/dashboard/students/:studentId/update", element: <StudentsRedirect /> },
    {
        path: "/settings/profile/:userId",
        element: (
            <PageHeader>
                <ProfileView />
            </PageHeader>
        ),
    },
    // Info Portal routes (accessible to all authenticated users)
    ...infoPortalRoutes,
];

export const StudentRouteWrapper = ({ children }) => (
    <HomeNavigation>{children}</HomeNavigation>
);
